import { Customer, ParentCustomer, SeriesAnswerEnquete } from 'src/@types/seriesEnquete';
import { RootState, store } from 'src/redux/store';

export const useCreateSeriesAnswerData = () => {
  const createSeriesAnswerData = (): SeriesAnswerEnquete => {
    // Reduxの現在のStateを読み取る
    const { customerGroups, currency } = (store.getState() as RootState).seriesAnswer;
    const counterparties: ParentCustomer[] = [];
    customerGroups.forEach((customerGroup) => {
      const customers: Customer[] = customerGroup.childrenCustomer.map((customer) => {
        return {
          customerCode: customer.customerCode,
          customerName: customer.customerName,
          customerNameEng: customer.customerNameEng,
          countryCode: customer.countryCode,
          countryName: customer.countryName,
          countryNameEng: customer.countryNameEng,
          regionCode: customer.regionCode,
          regionName: customer.regionName,
          regionNameEng: customer.regionNameEng,
          currencyUnit: currency,
          salesComment: customer.salesComment,
          purchaseComment: customer.purchaseComment,
          receivableBalance: customer.receivableBalance ?? null,
          payableBalance: customer.payableBalance ?? null,
          previousYear: {
            systemSalesAmount: customer.previousYear.systemSalesAmount,
            answerSalesAmount: customer.previousYear.answerSalesAmount,
            systemPurchaseAmount: customer.previousYear.systemPurchaseAmount,
            answerPurchaseAmount: customer.previousYear.answerPurchaseAmount,
            sourceType: customer.previousYear.sourceType,
            aggregateType: customer.previousYear.aggregateType,
          },
          currentYear: {
            systemSalesAmount: customer.currentYear.systemSalesAmount,
            answerSalesAmount: customer.currentYear.answerSalesAmount,
            systemPurchaseAmount: customer.currentYear.systemPurchaseAmount,
            answerPurchaseAmount: customer.currentYear.answerPurchaseAmount,
            sourceType: customer.currentYear.sourceType,
            aggregateType: customer.currentYear.aggregateType,
          },
        };
      });
      const parentCustomer = {
        parentCustomerCode: customerGroup.parentCustomerCode,
        parentCustomerName: customerGroup.parentCustomerName,
        parentCustomerNameEng: customerGroup.parentCustomerNameEng,
        customers: customers,
      };
      counterparties.push(parentCustomer);
    });

    // 保存する回答情報を作成する
    return {
      counterparties,
    };
  };

  return createSeriesAnswerData;
};
